import { Link } from "react-router-dom";
import { Star, ShieldCheck, Gem, ArrowRight } from "lucide-react";
import { FadeUp, SectionHead } from "@/components/Reveal";

const PILLARS = [
    { icon: Star, title: "Engineered Longevity", copy: "Every seam is drawn from data, then proven under stress." },
    { icon: ShieldCheck, title: "Lifetime Warranty", copy: "Fully protected against stitch and structural failures, for life." },
    { icon: Gem, title: "Quiet Luxury", copy: "Performance textiles chosen to outlive the trend cycle." },
];

export default function Philosophy() {
    return (
        <section className="mx-auto grid w-full max-w-[1400px] gap-12 px-5 py-24 md:px-8 md:py-32 lg:grid-cols-12 lg:px-10">
            <div className="lg:col-span-5">
                <SectionHead eyebrow="Our Philosophy" title="Worn. Lived In. Valued for Years." />
                <FadeUp delay={0.1}>
                    <p className="mt-6 max-w-md text-sm leading-relaxed text-mute md:text-base">
                        URWAN began with a simple observation: modern menswear trades longevity for
                        novelty. We answer with data-driven patterning, high-grade performance textiles,
                        and a lifetime promise — denim made to be worn hard, lived in, and kept.
                    </p>
                    <Link
                        to="/about"
                        data-testid="philosophy-about-link"
                        className="group mt-8 inline-flex items-center gap-3 text-[11px] font-mono uppercase tracking-[0.25em] text-gold"
                    >
                        Read the Full Story
                        <ArrowRight size={14} className="transition-transform group-hover:translate-x-1.5" />
                    </Link>
                </FadeUp>
            </div>
            <div className="grid gap-5 sm:grid-cols-3 lg:col-span-7 lg:items-stretch">
                {PILLARS.map((p, i) => (
                    <FadeUp key={p.title} delay={i * 0.1} className="h-full">
                        <div className="group flex h-full flex-col border border-white/10 bg-coal/60 p-7 transition-colors duration-300 hover:border-gold/50">
                            <span className="grid h-12 w-12 place-items-center rounded-full border border-gold/40 text-gold transition-colors duration-300 group-hover:bg-gold group-hover:text-black">
                                <p.icon size={20} />
                            </span>
                            <h3 className="mt-6 font-display text-lg font-bold uppercase leading-tight text-ink">
                                {p.title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-mute">{p.copy}</p>
                        </div>
                    </FadeUp>
                ))}
            </div>
        </section>
    );
}
